import React from 'react'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { ConnectedRouter } from 'connected-react-router'
import { MsalProvider } from '@azure/msal-react'

import { history } from './history'
import store from './store'
import App from './containers/App'
import './regexExtension'
import './styles/constants/index.scss'
import { registerServicePolling } from './servicePolling'
import { msalInstance } from './msalClient'

registerServicePolling()

render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </ConnectedRouter>
  </Provider>,
  document.querySelector('#root')
)
